<template>
    <div :class="position" class="" >
            <div v-if="item.type==='image'"  class="message-image bubble" :style="position=='leftfollow'?'border-radius: 0px 15px 15px 15px;flex-direction: column;':'border-radius: 15px 0px 15px 15px;flex-direction: column;'">
                <img class="mgsimg" v-if="!item.isDeleted" @click="showImg(item.message)" :src="item.message" alt="">
                <p class="timestamp">{{getTime(item.timestamp)}}</p>
            </div>
            <div v-if="item.type==='audio'" class="bubble " :style="position=='leftfollow'?'border-radius: 0px 15px 15px 15px;':'border-radius: 15px 0px 15px 15px;'">
                    <div class="audio w-full  flex justify-between">
                        <div v-if="!item.isDeleted" class="message w-full">
                            <audio class="audio_player" :src="item.message"  controls="controls" autobuffer="autobuffer"></audio>
                        </div>
                    <p class="timestamp">{{getTime(item.timestamp)}}</p>
                    </div>
                </div>
            <div v-if="item.type==='text'" class="txt bubble" :style="position=='leftfollow'?'border-radius: 0px 15px 15px 15px;':'border-radius: 15px 0px 15px 15px;'">
                <p v-if="!item.isDeleted" class="message">
                     <span v-if="isUrl(item.message)" v-html="replaceURLs(item.message)">
                     </span>
                      <span v-else :class="{'ar':item.lang=='ar'}">
                         {{item.message}}
                     </span>
                </p>
                <p class="timestamp">
                    {{getTime(item.timestamp)}}
                </p>
            </div>
            <!-- remove -->
            <!-- admin -->
            <!-- <span v-if="host=='admin' && item.admin && !item.isDelated" @click="localData.messageOptions=!localData.messageOptions" class="ops">
                <svg fill="#FFF" data-v-388c3261="" viewBox="0 0 24 24" height="23" width="23" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none; display: block;"><g data-v-388c3261="" class="style-scope yt-icon"><polygon data-v-388c3261="" points="18.4,14.6 12,8.3 5.6,14.6 6.4,15.4 12,9.7 17.6,15.4 " class="style-scope yt-icon"></polygon></g></svg>
            </span>
            <div v-if=" host=='admin' && localData.messageOptions && item.admin" @click="deleteMessage(item)" class="message-options">
                <div class="item">{{'livechat_remove'}}</div>
            </div> -->
            <!-- manager -->
            <!-- <span v-if="host=='manager' && !item.admin && !item.isDelated"  @click="localData.messageOptions=!localData.messageOptions" class="ops">
                <svg fill="#FFF" data-v-388c3261="" viewBox="0 0 24 24" height="23" width="23" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none; display: block;"><g data-v-388c3261="" class="style-scope yt-icon"><polygon data-v-388c3261="" points="18.4,14.6 12,8.3 5.6,14.6 6.4,15.4 12,9.7 17.6,15.4 " class="style-scope yt-icon"></polygon></g></svg>
            </span>
            <div v-if=" host=='manager' && localData.messageOptions && !item.admin" @click="deleteMessage(item)" class="message-options">
                <div class="item">{{'livechat_remove'}}</div>
            </div> -->
    </div>
</template>
<script>
export default {
  watch: {
  },
    props:[
        'item','position','host'
    ],
    data(){
        return{
            localData:{
                messageOptions:false
            }
        }
    },
    methods:{
        async download(item){
           let b64 = await this.getBase64(item)
           window.Location.href=b64
        },
                getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            })
                },
        deleteMessage(item){
            this.$emit('remove', item)
            this.localData.messageOptions=false
        },
        showMessageOptions(){
           this.localData.messageOptions=true
        },
         showImg(src){
           this.$emit('showImg',src)
        },
        getTime(lastMessageTime) {
            let time = null
            let ddate = null
            const diff = Date.now() - lastMessageTime
            const d = diff / (1000 * 60 * 60 * 24)
            const date = new Date(lastMessageTime)
                if (date.getMinutes() < 10) {
                    time = date.getHours() + ":0" + date.getMinutes()
                } else {
                    time = date.getHours() + ":" + date.getMinutes()
                }
            if (d >= 1) {   
                ddate =  date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear()
            }
            return ddate ? ddate+' - '+time : time
        }, 
        isUrl(text){
            if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(text)) {
                return true
            }else{
                return false
            }
        },
        removeTags(text){
            return text.replace(/(<([^>]+)>)/ig, "");
        },
        replaceURLs(message) {
            message = this.removeTags(message)
            if(!message) return; 
            var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            return message.replace(urlRegex, function (url) {
                var hyperlink = url;
                if (!hyperlink.match('^https?:\/\/')) {
                   hyperlink = 'http://' + hyperlink;
                }
                return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
            });
        }

    },

}
</script>
<style scoped>
.mgsimg{
    border-radius: 13px;
}
.rightfollow{
     width: 100%;
    display: flex;
    justify-content: flex-end;
}
.leftfollow{
    width: 100%;
    display: flex;
    justify-content: flex-start;

}
.audio .message audio{
  height: 32px;
  width: 100%;
  margin-top: 4px;
}
.bubble {
    width: 84%;
    height: auto;
    display: flex;
    position: relative;
    justify-content: space-between;
    padding-top: 0;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
}
.rightfollow .bubble {
    background-color: #4d9cf8
}
.leftfollow .bubble {
    background-color:#ffffff ;
}

.rightfollow .message-source {
    padding: 2px 4px;
    color: #f4fdff;
    background: #29839e;
    font-size: 13px;
    font-weight: 500;
}
.leftfollow .message-source {
    padding: 2px 4px;
    color: #31312ef7;
    background: #c9e2b5;
    font-size: 13px;
    font-weight: 500;
    text-align: left;
}
.message {
    padding: 10px 5px 10px 5px;
    font-size: 12.6px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: 100%;
    overflow-wrap: anywhere;
}
.ar{
   text-align: end;
}
.rightfollow .message {
    color: #FFFFFF;
} 
.rightfollow .message >>> a{
    color: rgb(255 255 255);
    text-decoration-line: underline;
    text-decoration-style: solid;
}
.rightfollow .message  >>> a:hover{
    color: #425954;
}
/*  */
.leftfollow .message {
    color: #363636;
}
.leftfollow .message >>> a{
  color: #363636;
  text-decoration-line: underline;
  text-decoration-style: solid;
}
.leftfollow .message  >>> a:hover{
  color: #175f62;
}

/*  */
.timestamp {
    padding: 2px 5px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    font-size: 12px;
}
.rightfollow .timestamp {
    color: #FFFFFF!important
}
.leftfollow .timestamp {
    color: #626262!important
}

.message-image img{
    max-width: 100%;
    max-height: 300px;
    cursor: pointer;
}
.rightfollow .message-image img{
    padding: 4px;
}
.leftfollow .message-image img{
        padding: 4px;

}
.retative{
    position: relative;
}
.ops{
    transform: rotate(180deg);
    top: -1px;
    right: 3px;
    position: absolute;
    cursor: pointer;
}
 .message-options{
     cursor: pointer;
    position: absolute;
    right: 3px;
    box-shadow: 0 0 3px 1px #4846463d;
    border-radius: 3px;
    text-align: center;
    padding-top: 4px;
    transition: all .5s ease;
    top: 20px;
    z-index: 2;
    height: 30px;
    width: 120px;
    background-color: #FFF;
}
</style>